import { render, staticRenderFns } from "./TextAndToolsPanel.vue?vue&type=template&id=87d1cc06&scoped=true&"
import script from "./TextAndToolsPanel.vue?vue&type=script&lang=js&"
export * from "./TextAndToolsPanel.vue?vue&type=script&lang=js&"
import style0 from "./TextAndToolsPanel.vue?vue&type=style&index=0&id=87d1cc06&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../abbreviation/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87d1cc06",
  null
  
)

export default component.exports